<div class="billet-modal-float-component" [ngClass]="{'confirmationBillit': showConfirmationBillit }"
  (window:beforeunload)="ngOnDestroy()">
  <div class="col-12 component-header">
    <span>{{ !showConfirmationBillit ? title : '' }}</span>
    <div class="icons gridster-ignore-drag">
      <mat-icon matSuffix class="gridster-ignore-drag engine" svgIcon="engine" [matTooltip]="toolTipEngine"
        [matMenuTriggerFor]="wksEngine"></mat-icon>
      <mat-menu class="custom-mat-menu worksheet settings-component mat-btn-wkst" #wksEngine="matMenu"
        [overlapTrigger]="false">
        <div class="col-12 box-title">
          <div class="row">
            <div class="col-10 p-0 title" (click)="stopPropagation()">Configurações Boleta</div>
            <div class="col-2">
              <mat-icon matSuffix svgIcon="close" [matTooltip]="'Fechar Configurações'"></mat-icon>
            </div>
          </div>
        </div>
        <div class="col-12" (click)="stopPropagation()">
          <div class="row align-items-center">
            <mat-slide-toggle class="toggle-theme small" [checked]="hiddenConfirmationBillet"
              (change)="showHiddenConfirmationBilliet()"></mat-slide-toggle>
            <span class="option-font">Ocultar PAD de confirmação</span>
          </div>
        </div>
      </mat-menu>
      <mat-icon disableWksChange svgIcon="close" (click)="close()"></mat-icon>
    </div>
  </div>
  <div class="col-12 billet-float-content">
    <ng-container *ngIf="loading || loadingStrategies; else elseTemplate">
      <div class="row spinner">
        <app-spinner-loading class="col-12"></app-spinner-loading>
      </div>
    </ng-container>
    <ng-template #elseTemplate>
      <ng-container *ngIf="!showConfirmationBillit; else templateConfirmation">
        <ng-container *ngTemplateOutlet="templateBillet"></ng-container>
      </ng-container>
    </ng-template>

  </div>
</div>

<ng-template #templateBillet>
  <div class="row" *ngIf="auctionHammer">
    <div class="col-12">
      <app-auction-hammer [timeToOpen]="timeToOpen" [priceTheory]="priceTheory" [varTheory]="varTheory">
      </app-auction-hammer>
    </div>
  </div>
  <div class="row">
    <div class="col-12 input-header">
      <app-asset-input-header [symbolAutoComplete]="symbol" (onsymbolChanged)="selectAsset($event)"
        [lastTrade]="lastTrade" [coinVariation]="coinVariation" [showVariation]="showVariation"
        [hiddenInvalid]="hiddenInvalid" [variation]="variation" [dateLastNegotiation]="messageQuote.dateLastNegotiation"
        [hourLastTrade]="messageQuote.hourLastTrade" [timeUpdate]="messageQuote.timeUpdate" [company]="model.company"
        [image]="imgName"></app-asset-input-header>
    </div>
  </div>
  <div class="row">
    <div class="col-12 m-billet">
      <mat-tab-group class="typeOrderWksFloat" id="scroll-typeOrder" (selectedTabChange)="changeTabSide($event)"
        [selectedIndex]="tabChangeSide">
        <mat-tab label="Comprar" class="border-buy">
          <div class="col-12">
            <app-billet-wks-inputs [withBackground]="true" [symbol]="symbol" [model]="model"
              [messageQuote]="messageQuote" [typeOrder]="model.type" [sideOrder]="model.side"
              [strategyOptions]="strategiesList" (openConfirmationBillit)="openModalConfirm($event)"
              [auctionHammer]="model?.auctionHammer" [typeOrderOptions]="typeOrderOptions" [listPosition]='listPosition'
              [isBilletFloat]="isBilletFloat" [typeOrderSelected]="typeOrderSelected"
              [financialAccount]="financialAccount">
            </app-billet-wks-inputs>
          </div>
        </mat-tab>
        <mat-tab label="Vender" class="border-sell">
          <div class="col-12">
            <app-billet-wks-inputs [withBackground]="true" [symbol]="symbol" [model]="model"
              [messageQuote]="messageQuote" [typeOrder]="model.type" [sideOrder]="model.side"
              [strategyOptions]="strategiesList" (openConfirmationBillit)="openModalConfirm($event)"
              [auctionHammer]="model?.auctionHammer" [typeOrderOptions]="typeOrderOptions" [listPosition]='listPosition'
              [isBilletFloat]="isBilletFloat" [typeOrderSelected]="typeOrderSelected"
              [financialAccount]="financialAccount">
            </app-billet-wks-inputs>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</ng-template>

<ng-template #templateConfirmation>
  <div class="row">
    <app-billet-wks-confirmation class="col-12" [model]="model" [indiceFuture]="indiceFuture" [lastTrade]="lastTrade"
      (loading)="setLoading($event)" (openConfirmationBillit)="closeModalConfirm($event)" [isBilletFloat]="true">
    </app-billet-wks-confirmation>
  </div>
</ng-template>
